import {
  CartesianGrid, LabelList, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis,
} from "recharts";
import { CORAL, MUTED, NAVY } from "../constants";
import { formatCompactNumber, formatCurrency, formatInteger } from "../formatters";

export function SurchargeTrendCard({ title, data }) {
  const { total, spend, trend } = data;
  const recentTrend = Array.isArray(trend) ? trend.slice(-6) : [];

  return (
    <div className="rounded-2xl bg-white border border-[#d6dfeb] shadow-sm overflow-hidden flex flex-col">
      <div className="px-5 pt-4 pb-3" style={{ borderBottom: "1px solid #e4e9f2" }}>
        <div className="flex items-center justify-between gap-3">
          <p className="text-[11px] font-black uppercase tracking-[0.14em]" style={{ color: NAVY }}>
            {title}
          </p>
          <span className="text-sm font-black flex-shrink-0" style={{ color: NAVY }}>
            Total: {formatInteger(total)}
          </span>
        </div>
      </div>

      <div className="px-2 pt-3 pb-1" style={{ height: 176 }}>
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={recentTrend} margin={{ top: 18, right: 12, left: 0, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#e4e9f2" />
            <XAxis
              dataKey="label"
              tick={{ fontSize: 9, fill: MUTED }}
              axisLine={false}
              tickLine={false}
            />
            <YAxis
              tick={{ fontSize: 9, fill: MUTED }}
              axisLine={false}
              tickLine={false}
              allowDecimals={false}
              tickFormatter={formatCompactNumber}
              width={34}
            />
            <Tooltip
              contentStyle={{ fontSize: 11, borderRadius: 8, border: "1px solid #d6dfeb", color: NAVY }}
              labelStyle={{ fontWeight: "bold", color: NAVY, marginBottom: 4 }}
            />
            <Line
              type="monotone"
              dataKey="count"
              name="Count"
              stroke={CORAL}
              strokeWidth={2}
              dot={{ r: 3, fill: CORAL, strokeWidth: 0 }}
              activeDot={{ r: 4 }}
            >
              <LabelList
                dataKey="count"
                position="top"
                offset={8}
                style={{ fill: NAVY, fontSize: 10, fontWeight: 700 }}
                formatter={(value) => formatInteger(value)}
              />
            </Line>
          </LineChart>
        </ResponsiveContainer>
      </div>

      <div className="px-5 pb-4 pt-2 flex items-center justify-between mt-auto">
        <div className="flex items-center gap-1.5">
          <div className="w-5 rounded" style={{ height: 2, background: CORAL }} />
          <span className="text-[10px]" style={{ color: MUTED }}>Count</span>
        </div>
        <span className="text-[11px] font-black" style={{ color: NAVY }}>
          Spend: {formatCurrency(spend)}
        </span>
      </div>
    </div>
  );
}
